import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  Exceptiondt2hlxn7j7vw as Exception,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { BufferedSourceJsonReader1eguw7qhrwt7p as BufferedSourceJsonReader } from './BufferedSourceJsonReader.mjs';
import { MapJsonReader2b7ri7r44421y as MapJsonReader } from './MapJsonReader.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function readAny(_this__u8e3s4) {
  var token = _this__u8e3s4.w41();
  var tmp;
  switch (token.w1_1) {
    case 9:
      tmp = _this__u8e3s4.o4d();
      break;
    case 8:
      tmp = _this__u8e3s4.no();
      break;
    case 7:
    case 6:
      tmp = guessNumber(_this__u8e3s4);
      break;
    case 5:
      tmp = _this__u8e3s4.s42();
      break;
    case 2:
      _this__u8e3s4.f42();
      // Inline function 'kotlin.collections.mutableMapOf' call

      var result = LinkedHashMap().ec();
      while (_this__u8e3s4.q1()) {
        result.x4(_this__u8e3s4.h42(), readAny(_this__u8e3s4));
      }

      _this__u8e3s4.g42();
      tmp = result;
      break;
    case 0:
      _this__u8e3s4.n42();
      // Inline function 'kotlin.collections.mutableListOf' call

      var result_0 = ArrayList().p2();
      while (_this__u8e3s4.q1()) {
        result_0.i2(readAny(_this__u8e3s4));
      }

      _this__u8e3s4.o42();
      tmp = result_0;
      break;
    default:
      // Inline function 'kotlin.error' call

      var message = 'unknown token ' + token.toString();
      throw IllegalStateException().o(toString(message));
  }
  return tmp;
}
function guessNumber(_this__u8e3s4) {
  try {
    return _this__u8e3s4.nk();
  } catch ($p) {
    if ($p instanceof Exception()) {
      var _unused_var__etf5q3 = $p;
    } else {
      throw $p;
    }
  }
  try {
    return _this__u8e3s4.ko();
  } catch ($p) {
    if ($p instanceof Exception()) {
      var _unused_var__etf5q3_0 = $p;
    } else {
      throw $p;
    }
  }
  try {
    return _this__u8e3s4.x42();
  } catch ($p) {
    if ($p instanceof Exception()) {
      var _unused_var__etf5q3_1 = $p;
    } else {
      throw $p;
    }
  }
  return _this__u8e3s4.l4g();
}
function jsonReader(_this__u8e3s4) {
  return new (BufferedSourceJsonReader())(_this__u8e3s4);
}
function jsonReader_0(_this__u8e3s4) {
  return new (MapJsonReader())(_this__u8e3s4);
}
//region block: exports
export {
  jsonReader as jsonReaderkr2c3w0efm9b,
  jsonReader_0 as jsonReader2agwreccj3lmk,
  readAny as readAny17j2jqaxubdko,
};
//endregion

//# sourceMappingURL=JsonReaders.mjs.map
